import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { LoginComponent } from './login/login.component';
import { VehiclePositionComponent } from './vehiclePosition/vehiclePosition.component';
import { VehicleRoutesComponent } from './vehicleRoutes/vehicleRoutes.component';
import { MapRoutesComponent } from './vehicleRoutes/mapRoutes/mapRoutes.component';
import { PositionRouteResolver } from './_resolvers/positions-route.resolver';
import { ForgotPassChangeComponent } from './forgot-pass-change/forgot-pass-change.component';
import { PassTokenResolver } from './_resolvers/pass-token.resolver';
import { ClientLayoutComponent } from './layouts/client/client-layout.component';
import { AdminGuard } from './_guards/admin.guard';
import { ClientGuard } from './_guards/client.guard';
import { ServiceManLayoutComponent } from './layouts/serviceMan/serviceMan-layout.component';
import { ServiceManGuard } from './_guards/serviceMan.guard';
import { TollDistributerGuard } from './_guards/tollDistributer.guard';
import { TollDistributerLayoutComponent } from './layouts/tollDistributerLayout/tollDistributerLayout.component';


export const AppRoutes: Routes = [
  {
    path: '',
    runGuardsAndResolvers: 'always',
    canActivate: [ServiceManGuard],
    component: ServiceManLayoutComponent,
    children: [{
      path: '',
      loadChildren: () => import('src/app/pages/serviceMan/serviceMan.module').then(m => m.ServiceManModule)
    }]
  },
  {
    path: '',
    runGuardsAndResolvers: 'always',
    canActivate: [ClientGuard],
    component: ClientLayoutComponent,
    children: [{
      path: '',
      loadChildren: () => import('src/app/pages/client/client.module').then(m => m.ClientModule)
    }]
  },
  {
    path: '',
    runGuardsAndResolvers: 'always',
    canActivate: [AdminGuard],
    component: AdminLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('src/app/pages/admin/admin.module').then(m => m.AdminModule)
      }
    ]
  },
  {
    path: '',
    runGuardsAndResolvers: 'always',
    canActivate: [TollDistributerGuard],
    component: TollDistributerLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('src/app/pages/srbTollDistributer/srbTollDistributer.module').then(m => m.SrbTollDistributersModule)
      }
    ]
  },
  {
    path: 'unauthorized',
    loadChildren: () => import('./unathorizedPages/unathorizedPages.module').then(m => m.UnathorizedPagesModule)
  },
  {
    path: '',
    runGuardsAndResolvers: 'always',
    canActivate: [AdminGuard],
    component: AdminLayoutComponent,
    children: [{
      path: 'vehicle',
      children: [
        {
          path: ':id',
          // resolve: { user: UserEditResolver },
          component: VehiclePositionComponent
        }
      ]
    }]
  },
  {
    path: '',
    runGuardsAndResolvers: 'always',
    canActivate: [AdminGuard],
    component: AdminLayoutComponent,
    children: [{
      path: 'routes',
      children: [
        {
          path: '',
          component: VehicleRoutesComponent
        },
        {
          path: ':date/:id',
          resolve: { positions: PositionRouteResolver },
          component: MapRoutesComponent
        }
      ]
    }]
  },
  // {
  //   path: '',
  //   runGuardsAndResolvers: 'always',
  //   canActivate: [AuthGuard],
  //   component: AdminLayoutComponent,
  //   children: [{
  //     path: 'users',
  //     component: ListUsersComponent
  //   }]
  // },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [{
      path: 'login',
      component: LoginComponent
    }]
  },
  {
    path: 'password/change',
    resolve: { token: PassTokenResolver },
    component: ForgotPassChangeComponent
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  }
];
